import React from "react";
import { motion } from "framer-motion";
import { images } from "../data/images";
interface QuizHeaderProps {
  showProgress: boolean;
  progress: number;
}
export function QuizHeader({
  showProgress,
  progress
}: QuizHeaderProps) {
  return <header className="sticky top-0 z-30 border-b border-blush-100 bg-cream/95 backdrop-blur" data-id="element-303" data-mp="1qj0f1x78hu6k">
      <div className="mx-auto flex h-16 max-w-5xl items-center justify-center gap-2.5 px-4 sm:px-6" data-id="element-304" data-mp="1llidwszgkj94">
        <img src={images.logo} alt="" className="h-10 w-10 rounded-full border border-blush-200 object-cover object-top" data-id="element-305" data-mp="1hlhq4hqgyvpe" />
        <span className="whitespace-nowrap font-serif text-lg font-semibold text-rose-600" data-id="element-306" data-mp="1crlx7tp2bz13">Mi Cocina Natural</span>
      </div>
      {showProgress && <div className="h-1.5 w-full bg-blush-100" role="progressbar" aria-valuemin={0} aria-valuemax={100} aria-valuenow={Math.round(progress * 100)} aria-label="Progreso del test" data-id="element-307" data-mp="12wliglsbrkpb">
          <motion.div className="h-full bg-rose-600" initial={false} animate={{
        width: `${Math.max(progress * 100, 3)}%`
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-308" data-mp="dhenr5umxrkk" />
        </div>}
    </header>;
}